// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Заголовок месяца
 */
.date_table__month__column__header__s0KKI {
    font-weight: bold;
    background: #ecd2b5;
    position: sticky;
    top: 0;
    z-index: 4;
}

/**
 * Месяц, год
 */
.date_year_title__TwMLz {
    width: 100%;
}

/**
 * День недели, число
 */
.date_week_title__vFBB4 {
    display: grid;
}

.date_table__weekday_cell__jR6Rh {
    border: 1px solid rgba(0, 0, 0, 0.44);
    box-sizing: border-box;
    padding: 0;
    width: var(--schedule-day-width);
    min-width: var(--schedule-day-width);
    max-width: var(--schedule-day-width);
    height: var(--schedule-row-height) !important;
    min-height: var(--schedule-row-height);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/date-info/date.module.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;;EAEE;AACF;IACI,WAAW;AACf;;AAEA;;EAEE;AACF;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,UAAU;IACV,gCAAgC;IAChC,oCAAoC;IACpC,oCAAoC;IACpC,6CAA6C;IAC7C,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":["/**\n * Заголовок месяца\n */\n.table__month__column__header {\n    font-weight: bold;\n    background: #ecd2b5;\n    position: sticky;\n    top: 0;\n    z-index: 4;\n}\n\n/**\n * Месяц, год\n */\n.year_title {\n    width: 100%;\n}\n\n/**\n * День недели, число\n */\n.week_title {\n    display: grid;\n}\n\n.table__weekday_cell {\n    border: 1px solid rgba(0, 0, 0, 0.44);\n    box-sizing: border-box;\n    padding: 0;\n    width: var(--schedule-day-width);\n    min-width: var(--schedule-day-width);\n    max-width: var(--schedule-day-width);\n    height: var(--schedule-row-height) !important;\n    min-height: var(--schedule-row-height);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table__month__column__header": `date_table__month__column__header__s0KKI`,
	"year_title": `date_year_title__TwMLz`,
	"week_title": `date_week_title__vFBB4`,
	"table__weekday_cell": `date_table__weekday_cell__jR6Rh`
};
export default ___CSS_LOADER_EXPORT___;
